import { Api, setAuthorization, removeAuthorization } from '@/api'
import { TokenSession } from '@/services/session'
import authFlags from '@/utils/flags/auth'

export default {
    async signin ({ commit, dispatch }, { username, password }) {
        commit('flags/SET_TRUE', authFlags.LOADING, { root: true })
        const response = await Api().auth.signin({ email: username, password })
        const { ok, data } = response
        if (ok && (data || {}).data) {
            const token = TokenSession.formatToken(data.data)
            await commit('SET_AUTH', token)
            setAuthorization(token)
            await dispatch('system/startup', null, { root: true })
            commit('flags/REMOVE', authFlags.LOADING, { root: true })
        } else {
            commit('flags/REMOVE', authFlags.LOADING, { root: true })
            await dispatch('notification/error', { ...response, duration: 3000 }, { root: true })
            throw new Error('error')
        }
    },
    async signout ({ commit, dispatch }) {
        await commit('CLEAN')
        await removeAuthorization()
        await dispatch('system/cleanAll', null, { root: true })
    },
}
